import { makeAutoObservable } from "mobx";
 import { IRootStore } from "./RootStore";
  
 export class RightSidebarStore {
     selectedItems = [] as any[];
  
     rootStore: IRootStore;
     constructor(rootStore: IRootStore) {
        makeAutoObservable(this);

         this.rootStore = rootStore;
     }

     setSelectedItems = (items: any[]) => {
         this.selectedItems = items;
     }
     get getSelectedItems() {
        return this.selectedItems;
    }
}